import React from 'react';
import { ErrorTemplate } from '../ErrorTemplate';
import { locale } from '../locale';
import { StatusLink } from '../RedirectLinks';
import PartialOutageErrorSvg from './PartialOutageError.svg';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const getErrorContext = level => {
  if (level === 'global') {
    return {
      heading: locale.partialOutage.heading,
      errorMessage: locale.partialOutage.globalErrorMessage
    };
  }
  if (level === 'tile') {
    return {
      heading: locale.partialOutage.tileHeading,
      errorMessage: locale.partialOutage.errorMessage
    };
  }
  return {
    heading: locale.partialOutage.sectionHeading,
    errorMessage: locale.partialOutage.errorMessage
  };
};
export const PartialOutageError = _ref => {
  let {
    level,
    heading,
    errorMessage,
    children
  } = _ref;
  const contextError = getErrorContext(level);
  const isGlobal = level === 'global';
  const finalHeading = level === 'component' ? null : heading || contextError.heading;
  const finalErrorMessage = errorMessage || contextError.errorMessage;
  return /*#__PURE__*/_jsxs(ErrorTemplate, {
    heading: finalHeading,
    image: PartialOutageErrorSvg,
    level: level,
    children: [finalErrorMessage, children, isGlobal && /*#__PURE__*/_jsxs(_Fragment, {
      children: [' ', locale.partialOutage.issuePersists, " ", /*#__PURE__*/_jsx(StatusLink, {}), " for updates."]
    })]
  });
};